import { Controller } from '@hotwired/stimulus'
import { application } from './application'

let asyncControllerLoaded = false

export default class extends Controller {
  connect () {
    if (!asyncControllerLoaded) {
      asyncControllerLoaded = true
      import('./three_d_remote_viewer_controller_async').then((module) => {
        application.unload('three-d-remote-viewer')
        application.register('three-d-remote-viewer', module.default)
      }, () => { })
    }
  }
}
